import React, { useState } from 'react';
import axios from 'axios';

const Formulario = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [data, setData] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare os dados para enviar para o SheetDB
    const dados = {
      nome: nome,
      email: email,
      data: data
    };

    try {
      // URL da API do SheetDB (substitua com a URL da sua API do SheetDB)
      const sheetDBUrl = 'https://sheetdb.io/api/v1/9odoxdosnhdu7';
      
      // Enviar os dados para o SheetDB usando axios
      const response = await axios.post(sheetDBUrl, { data: [dados] });

      console.log('Dados enviados com sucesso:', response.data);
      // Limpar os campos após o envio
      setNome('');
      setEmail('');
      setData('');
    } catch (error) {
      console.error('Erro ao enviar dados:', error);
    }
  };

  return (
    <div>
      <h1>Formulário de Envio de Dados</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nome:</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Data:</label>
          <input
            type="text"
            value={data}
            onChange={(e) => setData(e.target.value)}
            required
          />
        </div>
        <button type="submit">Enviar</button>
      </form>
    </div>
  );
};

export default Formulario;
